import React from "react";
import "./PrivacyPolicy.css";

function PrivacyPolicy() {
  return (
    <div className="privacy-page">
      <div className="privacy-container">
        <h1>Privacy Policy</h1>
        <p className="privacy-updated">Last updated: March 16, 2026</p>

        <p>
          Do I Need Sunscreen Right Now? ("the App") is developed by John
          Randolph. This privacy policy explains how the App handles your
          information.
        </p>

        <h2>Information We Collect</h2>
        <p>
          The App collects your device's location data solely to retrieve
          real-time UV index and weather conditions from Apple WeatherKit.
          Location data is sent directly to Apple's WeatherKit API and is not
          stored on any server we operate.
        </p>
        <p>
          The App stores your preferences (skin type, outdoor duration, surface
          type, notification settings) locally on your device using
          UserDefaults. These preferences are not transmitted to any external
          server.
        </p>

        <h2>Third-Party Services</h2>
        <p>
          The App uses Apple WeatherKit to retrieve UV index and weather data.
          Apple's use of your data is governed by{" "}
          <a
            href="https://www.apple.com/privacy/"
            target="_blank"
            rel="noopener noreferrer"
          >
            Apple's Privacy Policy
          </a>
          .
        </p>

        <h2>Data Sharing</h2>
        <p>
          We do not sell, share, or transmit any personal data to third parties.
          All data stays on your device or is sent directly to Apple's WeatherKit
          service.
        </p>

        <h2>Notifications</h2>
        <p>
          If you enable daily notifications, notification scheduling is handled
          entirely on-device. No data is sent to external push notification
          services.
        </p>

        <h2>Analytics</h2>
        <p>The App does not use any analytics or tracking SDKs.</p>

        <h2>Children's Privacy</h2>
        <p>
          The App does not knowingly collect personal information from children
          under 13.
        </p>

        <h2>Changes to This Policy</h2>
        <p>
          We may update this privacy policy from time to time. Changes will be
          posted on this page with an updated date.
        </p>

        <h2>Contact</h2>
        <p>
          If you have questions about this privacy policy, contact{" "}
          <a href="mailto:john_randolph@alumni.brown.edu">
            john_randolph@alumni.brown.edu
          </a>
          .
        </p>

        <div className="privacy-back">
          <a href="/">Back to sunscreen.fyi</a>
        </div>
      </div>
    </div>
  );
}

export default PrivacyPolicy;
